import * as React from 'react'
import { FC } from 'react'
import Box, { BoxProps } from '@mui/material/Box'

const ChatIcon: FC<BoxProps<'svg'>> = (props) => (
  <Box
    component="svg"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 34 34"
    fill="none"
    {...props}
  >
    <path
      d="M34 17C34 7.6112 26.389 0 17 0C7.611 0 0 7.6112 0 17C0 26.3888 7.611 34 17 34C26.389 34 34 26.3888 34 17Z"
      fill="white"
    />
    <path
      d="M15.5011 8.02961C14.6171 10.4435 15.2921 12.7671 16.7911 14.2663C17.8331 15.3077 19.2721 15.9514 20.8631 15.9514H22.9561V19.0262C22.9561 19.2565 23.2271 19.3802 23.4011 19.2295L28.6391 14.6954L28.9221 14.4547C28.9431 14.4337 28.9691 14.4128 28.9901 14.3918C30.1101 13.3452 30.8061 11.8486 30.8061 10.1949C30.8061 8.60401 30.1621 7.1649 29.1211 6.1235C28.0791 5.0821 26.6401 4.43851 25.0491 4.43851H20.8301C18.4881 4.43861 16.3051 5.83031 15.5011 8.02961Z"
      fill="#3D3C38"
    />
    <path
      d="M19.2931 12.8113H26.0961C26.3851 12.8113 26.6191 12.577 26.6191 12.288C26.6191 11.999 26.3851 11.7646 26.0961 11.7646H19.2931C18.9021 11.7646 18.6491 12.1778 18.8271 12.526C18.9161 12.7011 19.0961 12.8113 19.2931 12.8113Z"
      fill="#FF612B"
    />
    <path
      d="M19.2931 10.7185H26.0961C26.3851 10.7185 26.6191 10.4842 26.6191 10.1952C26.6191 9.90621 26.3851 9.67191 26.0961 9.67191H19.2931C18.9021 9.67191 18.6491 10.085 18.8271 10.4333C18.9161 10.6083 19.0961 10.7185 19.2931 10.7185Z"
      fill="#FF612B"
    />
    <path
      d="M19.2931 8.62479H26.0961C26.3851 8.62479 26.6191 8.39039 26.6191 8.10139C26.6191 7.81239 26.3851 7.57809 26.0961 7.57809H19.2931C18.9021 7.57809 18.6491 7.99129 18.8271 8.33949C18.9161 8.51459 19.0961 8.62479 19.2931 8.62479Z"
      fill="#FF612B"
    />
    <path
      d="M14.4419 12.8027H9.68294C7.88794 12.8027 6.26494 13.5287 5.09094 14.7033C3.91594 15.878 3.18994 17.5011 3.18994 19.2955C3.18994 21.1607 3.97495 22.8488 5.23795 24.0293C5.26195 24.053 5.29094 24.0766 5.31494 24.1002L5.63394 24.3717L11.5419 29.4858C11.7379 29.6558 12.0439 29.5162 12.0439 29.2565V25.7883H14.4049C16.1989 25.7883 17.8219 25.0622 18.9969 23.8876C20.6879 22.1966 21.4489 19.5757 20.4529 16.853C19.5449 14.3725 17.0829 12.8027 14.4419 12.8027Z"
      fill="#FF612B"
    />
    <path
      d="M16.1761 22.2469H8.50211C8.17611 22.2469 7.91211 21.9826 7.91211 21.6567C7.91211 21.3307 8.17611 21.0664 8.50211 21.0664H16.1761C16.6171 21.0664 16.9021 21.5325 16.7011 21.9252C16.6001 22.1226 16.3971 22.2469 16.1761 22.2469Z"
      fill="#3D3C38"
    />
    <path
      d="M16.1761 19.8866H8.50211C8.17611 19.8866 7.91211 19.6223 7.91211 19.2963C7.91211 18.9703 8.17611 18.7061 8.50211 18.7061H16.1761C16.6171 18.7061 16.9021 19.1721 16.7011 19.5648C16.6001 19.7623 16.3971 19.8866 16.1761 19.8866Z"
      fill="#3D3C38"
    />
    <path
      d="M16.1761 17.5252H8.50211C8.17611 17.5252 7.91211 17.261 7.91211 16.935C7.91211 16.609 8.17611 16.3447 8.50211 16.3447H16.1761C16.6171 16.3447 16.9021 16.8108 16.7011 17.2035C16.6001 17.4009 16.3971 17.5252 16.1761 17.5252Z"
      fill="#3D3C38"
    />
  </Box>
)

export default ChatIcon
